import React from 'react';
import './About.css';
import Footer from '../Footer';
import HeroSection from '../HeroSection';
import Offer from '../Offer';
import StatsSection from '../StatsSection';
import FeaturedEvent from '../FeaturedEvent';
import Newsletter from '../Newsletter';
import UpcomingEvents from '../UpcomingEvents';
import arrowIcon from "./assets/svg/arrow.svg";
import facebookIcon from './assets/svg/fa-facebook.svg';
import instagramIcon from './assets/svg/fa-instagram.svg';
import tiktokIcon from './assets/svg/fa-tiktok.svg';
import youtubeIcon from './assets/svg/fa-youtube.svg';

function About() {
  const videoCards = [
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    },
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    },
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    }
  ];

  return (
    <main>
      <HeroSection 
        title="Rólunk"
        text="A beszÉLJ! Egyesületet 2024 nyarán alapították olyan érintettek, akik maguk is dadogással és/vagy hadarással élnek. Mi vagyunk az első magyarországi szervezet, amelyet teljes egészében érintettek hoztak létre és működtetnek. Ez számunkra nemcsak egy támogató közösség, hanem erőforrás is: mi pontosan tudjuk, milyen kihívásokkal szembesülnek az érintettek és családjaik.
Célunk az életminőség javítása, a közösségi támogatás erősítése, valamint a társadalmi szemléletformálás. Tagjaink között olyan szakemberek is vannak (gyógypedagógus, lelkigondozó, sőt még logopédus is), akik maguk is érintettek, vagy érintettek családtagjai.
A fenti céljaink eléréséhez rendszeresen szervezünk olyan közösségi programokat, ahol tagjaink és az érdeklődők találkozhatnak személyesen vagy online. Emellett egy erős online közösséget építünk (Facebook, Instagram, TikTok, YouTube, új honlap), valamint számos egyetemi, fesztivál- és közösségi eseményen is bemutatkozunk.
Nekünk a Te mondanivalód is számít – beszÉLJ!
"
      />
      <Offer />
      <StatsSection />
      <section className="video-section">
        <h2 className="video-heading title-sm">Title goes here</h2>
        <div className="video-cards-container">
          <div className="video-cards-background"></div>
          <div className="video-cards">
            {videoCards.map((card, i) => (
              <div className="video-card-wrapper" key={i}>
                <div className="video-card">
                  <div className="video-placeholder"></div>
                  <h3 className="heading-md">{card.title}</h3>
                  <p className="body-sm">{card.description}</p>
                  <a href={card.link}>Learn more <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" /></a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="article-section">
        {[1, 2, 3, 4].map((_, i) => (
          <div className={`article-block ${i % 2 === 1 ? 'reverse' : ''}`} key={i}>
            <div className="article-image"></div>
            <div className="article-text">
              <h3 className="heading-sm">Title goes here</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
        ))}
      </section>

      <Newsletter />
      <FeaturedEvent />

      <section className="testimonial-section">
        <div className="testimonial-content">
          <div className="testimonial-image-box"></div>
          <div className="testimonial-quote">
            <p className="quote-text">„A szavaim néha elakadnak, de a gondolataim soha. Megtanultam, hogy nem a tökéletes beszéd tesz értékessé, hanem az, hogy merem elmondani, amit érzek.”</p>
            <p className="quote-author">NAME</p>
            <p className="quote-position">Position</p>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default About;
